export const assetsConfig = {
  notitlebar: 1,
  bonusName: '立减金',
  accountInsurance: '美团支付',
  addUrl: 'https://p0.meituan.net/travelcube/7516eb65839defbdcefac72866e447d6400.png',
  emptyUrl: 'https://p0.meituan.net/travelcube/b2daabcbca80a1bb775b2cb07b7cec9916675.png',
  finacingConfig: {
    jumpUrl: [
      'https://jarvas.meituan.com/dynamic/7d2d68e5/finance-2020-10-14-01.html/?autocookie=0',
      'https://jarvas.meituan.com/dynamic/7d2d68e5/finance-2020-10-22-01.html',
      'https://jarvas.meituan.com/dynamic/7d2d68e5/finance-2020-10-14-02.html/?autocookie=0',
      'https://jarvas.meituan.com/dynamic/7d2d68e5/finance-2020-10-22-02.html',
    ],
  },
};
